export default "__VITE_ASSET__O2Lk8o1m__"